import { maxContainerWidth } from './appConstants'

export const epgPagePath = '/epg'
export const epgProgramMinHeight = 45
export const epgProgramScrollOffset = 3
export const epgColumnMinWidth = 304
export const filterDayTimes = ['morning', 'afternoon', 'evening']
export const maxEpgColumnsAmount = Math.floor(
    maxContainerWidth / epgColumnMinWidth
)
export const epgColumnsWidthRatio = 3.6 / 1440
export const epgSliceSpeed = 1000

export const epgProgramScrollTopOffset = 200
export const epgProgramAutoScrollDelay = 200

export const programIsPrevious = -1
export const programRunningNow = 0
export const programIsFuture = 1

export const epgDataKey = 'epgData'
export const epgChannelsRequestAmount = 15
export const MILIS_24h = 24 * 60 * 60 * 1000
export const MILIS_6h = 6 * 60 * 60 * 1000
export const MILIS_10m = 10 * 60 * 1000
export const PAST_TIME_RANGE = 2 * 60 * 60 * 1000
export const MAX_PROGRAMS_PER_CHANNEL_FETCH_AMOUNT = 100
export const PROGRAMS_LENGTH_LIMIT = 1000
export const MINIMUM_VISIBLE_PROGRAMS = 20
export const MAX_FETCH_ATTEMPTS = 10
export const MAX_CHANNELS_PER_EPG_FETCH_CHUNK = 10
